export const processHtml = (html: string) =>
  html.replace(/<style[^>]*>([\s\S]*?)<\/style>/g, (match, css) => `<style>.safe-html-container { ${css} }</style>`);
